// @ts-nocheck
const APP_URL = process.env.VUE_APP_URL;

export function setDefaultImage(event, defaultImage, imagePath) {
  const img = new Image();
  img.src = APP_URL + imagePath;
  img.onerror = () => {
    event.target.src = process.env.VUE_APP_DEFAULT_IMAGE
  };
}

export function setDefaultBackgroundImage(event, defaultImage, imagePath) {
  const img = new Image();
  img.src = APP_URL + imagePath;
  img.onerror = () => {
    event.target.style.backgroundImage = `url(${defaultImage})`;
  };
}

export function getImageUrl(pathImage) {
  if (pathImage) {
    return APP_URL + pathImage;
  } else {
    return process.env.VUE_APP_DEFAULT_IMAGE
  }
}



